import React from 'react';
import {
  Card,
  Typography,
  LinearProgress,
} from '@mui/material';
import CreditProgressBar from '../CreditProgressBar';
import useStyles from './styles';
import { CreditOverviewProps } from '../../types/account';

export const productTypeLabels: {[key:string]:string} = {
  consumer: 'Consumo',
  microLoan: 'Avance',
  mortgage: 'Hipotecario',
  downPayment: 'Pie hipotecario',
  bnpl: 'Compra ahora, paga después',
};

export default function CreditOverview(props: CreditOverviewProps) {
  const {
    paidInstallments,
    totalInstallments,
    totalAmount,
    hasDelinquency,
    currency,
    minimalistView,
  } = props;
  const classes = useStyles();
  const barValue = Math.min(
    100,
    Math.max(
      0,
      (paidInstallments / totalInstallments) * 100,
    ),
  );
  return (
    <Card
      className={classes.creditOverview}
      sx={{
        borderRadius: '15px',
      }}
    >
      <div style={{ margin: 'auto' }}>
        <Typography
          variant="h5"
          gutterBottom
          fontWeight="bold"
          color={hasDelinquency ? 'error' : 'green'}
        >
          {hasDelinquency ? 'Moroso' : 'Al día'}
        </Typography>
        <div>
          <Typography
            variant="h6"
            color="secondary"
            display="inline"
            fontWeight="bold"
          >
            {paidInstallments}
            {' '}
            de
            {' '}
            {totalInstallments}
            {' '}
            cuotas
          </Typography>
          <Typography
            variant="h6"
            display="inline"
            fontWeight="light"
          >
            {' '}
            pagadas
          </Typography>
        </div>

      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 10fr 1fr' }}>
        <div />
        { !minimalistView ? (
          <CreditProgressBar
            paidInstallments={paidInstallments}
            totalInstallments={totalInstallments}
            totalAmount={totalAmount}
            currency={currency}
          />
        ) : (
          <LinearProgress
            color="secondary"
            variant="determinate"
            value={barValue}
            className={classes.progress}
          />
        )}
        <div />
      </div>
    </Card>
  );
}
